import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../HomeComponent/Navbar';
import FooterComponent from '../Footer/FooterComponent';
import { FaQuestionCircle, FaBook, FaHeadset, FaSearch } from 'react-icons/fa';

const HelpCenter = () => {
    return (
        <>
            <Navbar />
            <div style={{ paddingTop: '100px', minHeight: '100vh', background: '#f8fafc', fontFamily: "'Inter', sans-serif' " }}>

                {/* Hero Search Section */}
                <div style={{ background: '#1e293b', padding: '80px 20px', textAlign: 'center', color: 'white' }}>
                    <div style={{ maxWidth: '800px', margin: '0 auto' }}>
                        <h1 style={{ fontSize: '3rem', fontWeight: 'bold', marginBottom: '16px' }}>How can we help?</h1>
                        <p style={{ fontSize: '1.25rem', color: '#94a3b8', marginBottom: '40px' }}>
                            Search our knowledge base or browse categories below.
                        </p>

                        <div style={{ position: 'relative', maxWidth: '600px', margin: '0 auto' }}>
                            <FaSearch style={{ position: 'absolute', left: '20px', top: '50%', transform: 'translateY(-50%)', color: '#94a3b8' }} />
                            <input
                                type="text"
                                placeholder="Search for answers..."
                                style={{
                                    width: '100%',
                                    padding: '16px 20px 16px 50px',
                                    borderRadius: '50px',
                                    border: 'none',
                                    fontSize: '1rem',
                                    boxShadow: '0 10px 25px -5px rgba(0,0,0,0.1)'
                                }}
                            />
                        </div>
                    </div>
                </div>

                {/* Categories Grid */}
                <div style={{ maxWidth: '1200px', margin: '-40px auto 60px', padding: '0 20px', position: 'relative', zIndex: 10 }}>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px' }}>

                        <HelpCard
                            to="/faq"
                            icon={<FaQuestionCircle size={32} color="#3b82f6" />}
                            title="FAQ"
                            description="Find answers to common questions about our features, pricing, and account management."
                        />

                        <HelpCard
                            to="/blogs"
                            icon={<FaBook size={32} color="#10b981" />}
                            title="Guides & Tutorials"
                            description="Step-by-step guides to help you master ToxBoxAI and streamline your workflow."
                        />

                        <HelpCard
                            to="/contact"
                            icon={<FaHeadset size={32} color="#f59e0b" />}
                            title="Customer Support"
                            description="Need personalized help? Contact our friendly support team for assistance."
                        />

                    </div>
                </div>

                {/* Popular Articles */}
                <div style={{ maxWidth: '800px', margin: '0 auto 80px', padding: '0 20px' }}>
                    <h2 style={{ fontSize: '1.5rem', fontWeight: '700', color: '#1e293b', marginBottom: '30px', textAlign: 'center' }}>Popular Articles</h2>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                        <ArticleLink title="How to integrate with Salesforce?" />
                        <ArticleLink title="Understanding your billing statement" />
                        <ArticleLink title="Setting up your first AI agent" />
                        <ArticleLink title="Troubleshooting voice latency issues" />
                    </div>
                </div>

            </div>
            <FooterComponent />
        </>
    );
};

const HelpCard = ({ to, icon, title, description }) => (
    <Link to={to} style={{ textDecoration: 'none' }}>
        <div style={{
            background: 'white',
            padding: '40px',
            borderRadius: '16px',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
            height: '100%',
            transition: 'transform 0.2s, box-shadow 0.2s'
        }}
            onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
            }}
        >
            <div style={{ marginBottom: '20px' }}>{icon}</div>
            <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#1e293b', marginBottom: '12px' }}>{title}</h3>
            <p style={{ color: '#64748b', lineHeight: '1.6' }}>{description}</p>
        </div>
    </Link>
);

const ArticleLink = ({ title }) => (
    <div style={{
        padding: '20px',
        background: 'white',
        borderRadius: '12px',
        border: '1px solid #e2e8f0',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        transition: 'border-color 0.2s'
    }}
        onMouseEnter={(e) => e.currentTarget.style.borderColor = '#3b82f6'}
        onMouseLeave={(e) => e.currentTarget.style.borderColor = '#e2e8f0'}
    >
        <span style={{ fontWeight: '500', color: '#334155' }}>{title}</span>
        <span style={{ color: '#94a3b8' }}>→</span>
    </div>
);

export default HelpCenter;
